import { render, staticRenderFns } from "./yhzzdform.vue?vue&type=template&id=615050b8&scoped=true&"
import script from "./yhzzdform.vue?vue&type=script&lang=js&"
export * from "./yhzzdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615050b8",
  null
  
)

export default component.exports